import { Component, OnDestroy } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

interface IRouterLinkParams extends ICellRendererParams {
  editTooltip: string;
  viewTooltip: string;
}

@Component({
  selector: "ag-grid-router-link-renderer",
  template: ` <a title="View details" class="circle" *ngIf="canView" [routerLink]="[params.value]">
      <em class="material-icons-outlined">visibility</em>
    </a>
    <a title="Modify" class="circle" *ngIf="canEdit" [routerLink]="[params.value, 'edit']">
      <em class="material-icons">edit</em>
    </a>`,
  standalone: false,
})
export class RouterLinkRenderer implements ICellRendererAngularComp, OnDestroy {
  canEdit: boolean;
  canView: boolean;
  params: IRouterLinkParams;
  agInit(params: IRouterLinkParams): void {
    this.params = params;
    this.canEdit = params.data.canEdit;
    this.canView = params.data.canView;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  ngOnDestroy() {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
